<script setup lang="ts">
import { CalendarCheck01Icon } from '@gohighlevel/ghl-icons/24/outline'
import {
  UIModal,
  UIModalFooter,
  UIModalHeader,
  UISelect,
} from '@gohighlevel/ghl-ui'

import Team from '@/models/team'
import AppState from '@/states/app'
import { computed, ref, watch } from 'vue'
const props = defineProps({
  show: Boolean,
  disabledConfirm: Boolean,
  currentTeam: {
    type: String,
    default: '',
  },
})

const emit = defineEmits(['onConfirm', 'onModalClose', 'update:show'])

const handleSave = () => {
  if (props.currentTeam === selectedTeam.value) {
    return alert('Please select a different group')
  }

  emit('onConfirm', selectedTeam.value)
}
const handleCancel = () => {
  emit('onModalClose')
}

const teams = computed(() => {
  return AppState.globalTeams?.teams || []
})

const teamOptions = computed(() => {
  const teamOptions = teams.value.map((team: Team) => ({
    label: team.name,
    value: team.id,
  }))

  return [
    {
      label: 'Unassigned (No Group)',
      value: '',
    },
    ...teamOptions,
  ]
})

const selectedTeam = ref('')

watch(
  () => props.show,
  () => {
    selectedTeam.value = props.currentTeam as string
  }
)
</script>

<template>
  <UIModal
    id="generalConfirmationModal"
    :width="500"
    :show="show"
    @update:show="val => $emit('update:show', val)"
  >
    <template #header>
      <UIModalHeader
        id="generalConfirmationModalHeader"
        type="primary"
        :title="$t('settings.calendar.select_calendar_group')"
        :icon="CalendarCheck01Icon"
        @close="handleCancel"
      />
    </template>

    <UISelect
      id="select-team"
      v-model:value="selectedTeam"
      :placeholder="$t('placeholders.select_one')"
      :options="teamOptions"
      class="mb-2"
    />

    <template #footer>
      <UIModalFooter
        id="generalConfirmationModalFooter"
        :negative-text="$t('settings.calendar.cancel')"
        :positive-text="$t('settings.calendar.select')"
        :loading="disabledConfirm"
        :disabled="disabledConfirm"
        @negative-click="handleCancel"
        @positive-click="handleSave"
      />
    </template>
  </UIModal>
</template>
